import React from 'react';
import moment from 'moment';
import { Box } from '@mui/material';
import { DATE_FORMAT } from 'framework/utils';
import type { HeatmapBarSegment, TimelineDay } from '../types';
import { getBarPixels } from '../helpers';
import { Tooltip } from 'framework/ui/mui-builder';

interface HeatmapRowProps {
  days: TimelineDay[];
  bars?: HeatmapBarSegment[];
  barHeight?: number;
  height?: number;
}

const formatBarTooltip = (bar: { startDate: string; endDate: string; label?: string }): React.ReactNode => {
  const start = moment(bar.startDate).format(DATE_FORMAT.FULL_DATE);
  const end = moment(bar.endDate).format(DATE_FORMAT.FULL_DATE);
  const period = `${start} – ${end}`;
  if (bar.label) {
    return (
      <>
        <div>{bar.label}</div>
        <div>{period}</div>
      </>
    );
  }
  return period;
};

const HeatmapRow: React.FC<HeatmapRowProps> = ({ days, bars = [], barHeight = 5, height = 32 }) => (
  <Box
    sx={{
      position: 'relative',
      minHeight: height,
      height,
    }}
  >
    {bars.map(bar => {
      const { left, width } = getBarPixels(days, bar.startDate, bar.endDate);
      if (width === 0) return null;
      const tooltipTitle = formatBarTooltip(bar);
      return (
        <Tooltip key={bar.id} title={tooltipTitle} placement="top" followCursor>
          <Box
            sx={{
              position: 'absolute',
              left,
              width,
              height: barHeight,
              top: '50%',
              transform: 'translateY(-50%)',
              borderRadius: '3px',
              bgcolor: bar.color ?? 'error.main',
            }}
          />
        </Tooltip>
      );
    })}
  </Box>
);

export default React.memo(HeatmapRow);
